import React from "react";
import "./UniqueBanner.css";

const UniqueBanner = ({ image, title, subtitle, buttonText, buttonLink }) => {
  return (
    <section
      className="unique-banner-section"
      aria-label={typeof title === "string" ? title : "NIECCE education"}
    >
      <img
        src={image}
        alt={typeof title === "string" ? `${title} at NIECCE` : "NIECCE education banner"}
        title={typeof title === "string" ? `${title} at NIECCE` : "NIECCE education banner"}
        className="unique-banner-image"
      />
      <div className="unique-banner-overlay">
        <div className="unique-banner-content">
          <h1 className="unique-banner-title">{title}</h1>
          <p className="unique-banner-subtitle">{subtitle}</p>
        </div>
      </div>
    </section>
  );
};

export default UniqueBanner;
